import { generateMaterialTheme } from "commons/src/helpers/MaterialThemeHelpers";

export function generateGoMuiTheme(theme) {
    const baseMuiTheme = generateMaterialTheme(theme);

    return {
        ...baseMuiTheme,
        palette: {
            ...baseMuiTheme.palette,
            status: { success: "#62893d", fail: "#a92d26" }
        },
        components: {
            ...baseMuiTheme.components,
            MuiPaper: { styleOverrides: { root: { color: "inherit" } } }
        },
        typography: {
            ...baseMuiTheme.typography,
            body1: {
                ...baseMuiTheme.typography.body1,
                color: baseMuiTheme.palette.text.secondary
            },
            body2: {
                ...baseMuiTheme.typography.body2,
                color: baseMuiTheme.palette.text.secondary
            }
        }
    };
}
